import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { Route, useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import {
  ArrowRight,
  Close,
  GridView,
  Home,
  PersonAdd,
  SettingsSuggest,
} from "@mui/icons-material";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import InsuranceIcon from "../../../assets/SVG/insuranceIcon";
import PathologyIcon from "../../../assets/SVG/pathology";
import ReportIcon from "../../../assets/SVG/ReportIcon";
import AppointmentIcon from "../../../assets/SVG/AppointmentIcon";
import EmployIcon from "../../../assets/SVG/EmployIcon";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AccessConfigIcon from "../../../assets/SVG/AccessConfigIcon";
import { useSelector } from "react-redux";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import { fetchProfileData } from "../../../redux/reducers/profileSlice";
import { Roles } from "../../../enums";
import { title } from "process";
import OPDIcon from "../../../assets/SVG/OPDIcon";
import { fetchProjectProfileData } from "../../../redux/reducers/projectProfileSlice";
import IPDicon from "../../../assets/SVG/IPDicon";
import WhatsAppButtonWithTooltip from "../../WhatsAppButton";
import { UploadFileOutlined } from "@mui/icons-material";
// import AddNewTest from '../../pathology/add-new-test';
import BloodtypeIcon from "@mui/icons-material/Bloodtype";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { EyeIcon } from "lucide-react";
import { getHospitalReportsAccess } from "../../../pages/hospital-reports/access";
interface SideBarProps {
  isOpen: boolean;
  closeDrawer: () => void;
}
const SideBar: React.FC<SideBarProps> = ({ isOpen, closeDrawer }) => {
  const isSmallScreen = useMediaQuery(" (max-width:960px)");
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const navigate = useNavigate();
  const [activeSubMenu, setActiveSubMenu] = useState<string>("");
  const [subIndex, setSubIndex] = useState<number | null>(null);
  const [activeInnerMenu, setActiveInnerMenu] = useState<string>("");
  const location = useLocation();

  const profile = useSelector((state: any) => state.profileSlice.profile);
  const category = profile?.data?.userType;
  const userAccess = profile?.data?.roles;
  const profileLoading = useSelector(
    (state: any) => state.profileSlice.loading,
  );
  const projectProfile = useSelector(
    (state: any) => state?.projectProfileSlice?.projectProfile,
  );

  const accessConfigurations: any = profile?.data?.accessConfigurations;
  const specialization = profile?.data?.specialization;

  let options: any = [];

  let pathology = {
    title: "Lab",
    icon: <PathologyIcon />,
    patch: "mylab/dashboard",
    subMenu: [
      {
        title: "Settings",
        route: "/settings/test-tab",
      },
      {
        title: "Lab Settings",
        route: "/lab-settings/collection-center",
      },
      {
        title: "Add Test",
        route: "/test-tab/create-test",
      },
      {
        title: "Registration",
        route: "/sample-collection",
      },
      {
        title: "Samples",
        route: "/sample",
      },
      {
        title: "Test Results",
        route: "/test-result",
      },
      {
        title: "Critical Reports",
        route: "/critical-reports",
      },
      {
        title: "Lab Expense",
        route: "/lab-expense",
      },
    ],
    priority: 105,
  };

  let opd = {
    title: "OPD",
    icon: <OPDIcon />,
    subMenu: [
      {
        title: "Dashboard",
        route: "/opd-dashboard",
      },
      {
        title: "Settings",
        route: "/opd-admin",
        innerSubMenu: [
          {
            title: "Medicine",
            route: "/add-new-medicine",
            newInnerSubMenuMedicine: [
              {
                title: "Medicine Generic",
                route: "/generic",
              },
              {
                title: "Route Administration",
                route: "/adminstration",
              },
              {
                title: "Dosage",
                route: "/dosage",
              },
            ],
          },
          {
            title: "Provisional Diagnosis/DD",
            route: "/diagnosis",
          },
          {
            title: "Investigations",
            route: "/procedure",
          },
          {
            title: "History , Examination & Procedure",
            route: "/symptoms",
          },
          {
            title: "Case",
            route: "/case-dashboard",
          },
          {
            title: "Set of instructions",
            route: "/set-instructions",
          },
          {
            title: "Report Templates",
            route: "/report-templates",
          },
        ],
      },
    ],
    priority: 120,
  };
  let eyeopd = {
    title: "EYE OPD",
    icon: <EyeIcon />,
    subMenu: [
      {
        title: "Dashboard",
        route: "/eye/opd-dashboard",
      },
      {
        title: "Settings",
        route: "/eye/opd-admin",
        innerSubMenu: [
          {
            title: "Medicine",
            route: "/eye/add-new-medicine",
            newInnerSubMenuMedicine: [
              {
                title: "Medicine Generic",
                route: "/eye/generic",
              },
              {
                title: "Route Administration",
                route: "/eye/adminstration",
              },
              {
                title: "Dosage",
                route: "/eye/dosage",
              },
            ],
          },
          {
            title: "Provisional Diagnosis/DD",
            route: "/eye/diagnosis",
          },
          {
            title: "Investigations",
            route: "/eye/procedure",
          },
          {
            title: "History , Examination & Procedure",
            route: "/eye/symptoms",
          },
          {
            title: "Case",
            route: "/eye/case-dashboard",
          },
          {
            title: "Set of instructions",
            route: "/eye/set-instructions",
          },
        ],
      },
    ],
    priority: 130,
  };
  // options.push(eyeopd); // Removed unconditional push

  let account = {
    title: "Account",
    icon: <LocalAtmOutlinedIcon />,
    // patch: "/account/dashboard",
    subMenu: [
      {
        title: "Setting",
        route: "/account-setting/expense",
      },
      {
        title: "Procedure",
        route: "/account/income",
      },
      {
        title: "Expense",
        route: "/account/expense",
      },
    ],
    priority: 55,
  };
  let incomeExpens = {
    title: "Income & Expense",
    icon: <LocalAtmOutlinedIcon />,

    priority: 58,
    subMenu: [
      {
        title: "Settings",
        route: "/income&expense/income_category",
      },
      {
        title: "Income",
        route: "/income&expense/income",
      },
      {
        title: "Expense",
        route: "/income&expense/expense",
      },
      ...(projectProfile?.departmentsAccess?.includes("expense_payments")
        ? [
            {
              title: "Expense Payments",
              route: "/income&expense/expense-payments",
            },
          ]
        : []),
    ],
  };
  // Only include Income & Expense menu when project profile allows it
  if (projectProfile?.departmentsAccess?.includes("income_expense")) {
    options.push(incomeExpens);
  }

  let ipd = {
    title: "IPD",
    icon: <IPDicon />,
    // patch: '',
    subMenu: [
      {
        title: "Dashboard",
        route: "/ipd-dashboard",
      },
      {
        title: "Setting",
        // route: '/infrastructure',
        innerSubMenu: [
          {
            title: "Infrastructure",
            route: "/infrastructure",
          },

          {
            title: "Services",
            route: "/services",
          },

          {
            title: "Templates",
            route: "/ipd-template",
          },
          {
            title: "Add Antibiotic",
            route: "/add-antibiotic",
          },
        ],
      },
    ],
    priority: 135,
  };

  let bloodDonor = {
    title: "Blood Bank",
    icon: <BloodtypeIcon />,
    patch: "/blood-bank",
    subMenu: [
      {
        title: "Cross Match Report",
        route: "/blood-bank/cross-match-report",
      },
      {
        title: "Donors",
        route: "/donor-history",
        innerSubMenu: [
          {
            title: "Add Donor",
            route: "/add-donor",
          },

          {
            title: "Donor Screening",
            route: "/donor-screening",
          },
          {
            title: " Screening Reports",
            route: "/donor-screening-reports",
          },
        ],
      },

      {
        title: "Blood Bag",
        route: "/donor-bag",
      },
      {
        title: "Bag Close To Expire",
        route: "/donor-bag-expiry",
      },
      {
        title: "Patient Slip",
        route: "/patient-slip",
      },
      {
        title: "Inventory",
        innerSubMenu: [
          {
            title: "Available Stock",
            route: "/available-stock",
          },
          {
            title: "Payment Statement",
            route: "/payment-statement",
          },
        ],
      },

      {
        title: "Crossmatch",
        route: "/blood-crossmatch",
      },
      {
        title: "Settings",
        route: "/blood-bank/settings/blood-component",
      },
    ],
    priority: 150,
  };
  let pharmacy = {
    title: "Pharmacy",
    icon: <LocalPharmacyIcon />,
    patch: "/pharmacy",
    priority: 160,
  };
  let hospitalReports = {
    title: "Hospital Reports",
    icon: <AssessmentOutlinedIcon />,
    patch: "/hospital-reports",
    priority: 170,
  };
  // options?.push(bloodDonor)
  projectProfile?.departmentsAccess &&
    projectProfile?.departmentsAccess?.forEach((department: string) => {
      switch (department) {
        case "account":
          options.push(account);
          break;
        case "ipd":
          options.push(ipd);
          break;
        case "blood_bank":
          options.push(bloodDonor);
          break;
        case "pharmacy": {
          const isAdmin =
            Array.isArray(category) &&
            category.some(
              (t: string) =>
                String(t).toLowerCase() === "admin" ||
                String(t).toLowerCase() === "superadmin",
            );
          const pharmacyAccess =
            accessConfigurations?.Pharmacy ||
            accessConfigurations?.pharmacy ||
            {};
          if (isAdmin || pharmacyAccess?.view_module) {
            options.push(pharmacy);
          }
          break;
        }
        default:
          break;
      }
    });
  const hospitalReportsAccess = getHospitalReportsAccess(
    accessConfigurations,
    category,
  );
  if (
    category?.includes("admin") ||
    category?.includes("superAdmin") ||
    hospitalReportsAccess.view_module
  ) {
    options.push(hospitalReports);
  }
  // Add Diagnostic Services based on department access
  if (projectProfile?.departmentsAccess?.includes("diagnostic_services")) {
    const basePath =
      specialization?.toLowerCase()?.trim() === "ophthalmologist"
        ? "/eye"
        : "";
    options.push({
      title: "Diagnostic Services",
      icon: <ReportIcon />,
      patch: `${basePath}/diagnostic-services`,
      priority: 115,
    });
  }

  // Add OPD based on specialization
  if (
    specialization?.toLowerCase()?.trim() === "ophthalmologist" &&
    projectProfile?.departmentsAccess?.includes("opd")
  ) {
    options.push(eyeopd);
  } else if (projectProfile?.departmentsAccess?.includes("opd")) {
    options.push(opd);
  }
  accessConfigurations &&
    Object.keys(accessConfigurations).map((key) => {
      switch (key) {
        case "appointment":
          if (accessConfigurations[key]?.view_module) {
            let data = {
              title: "Appointments",
              icon: <AppointmentIcon />,
              patch: "/appointment-dashboard",
              subMenu: [
                {
                  title: "Reports",
                  route: "/user-reports",
                },
                {
                  title: "Counter",
                  route: "/counter",
                },
                {
                  title: "Delete History",
                  route: "/delete-history",
                },
              ],
              priority: 0,
            };

            if (projectProfile?.departmentsAccess?.includes("registration")) {
              if (projectProfile?.departmentsAccess?.includes("Report")) {
                options.push(data);
              } else {
                const newData = data.subMenu.filter(
                  (item) => item.title !== "Reports",
                );
                options.push({ ...data, subMenu: newData });
              }
            }
          }
          break;

        case "employee":
          if (accessConfigurations[key]?.view_module) {
            let data = {
              title: "Employee",
              icon: <EmployIcon />,
              patch: "/employee",
              subMenu: [
                {
                  title: "Category",
                  route: "/employe-category",
                },
                {
                  title: "Add Employe",
                  route: "/add-employe/bio",
                },
                {
                  title: "Departments",
                  route: "/add-department",
                },
              ],
              priority: 30,
            };

            if (!accessConfigurations[key]?.view_category) {
              let index = data?.subMenu?.findIndex(
                (item: any) => item?.route === "/employe-category",
              );
              data?.subMenu?.splice(index, 1);
            }
            if (!accessConfigurations[key]?.view_department) {
              let index = data?.subMenu?.findIndex(
                (item: any) => item.route === "/add-department",
              );
              data?.subMenu?.splice(index, 1);
            }
            if (!accessConfigurations[key]?.add_employee) {
              let index = data?.subMenu?.findIndex(
                (item: any) => item.route === "/add-employe/bio",
              );
              data?.subMenu?.splice(index, 1);
            }
            if (projectProfile?.departmentsAccess?.includes("registration")) {
              options.push(data);
            }
          }
          break;
        case "insurance":
          if (accessConfigurations[key]?.view_module) {
            let data = {
              title: "Insurance",
              icon: <InsuranceIcon />,
              patch: "/insurance-dashboard",
              subMenu: [
                {
                  title: "Insurance Cards",
                  route: "/insurance-cards",
                },
                {
                  title: "Insurance Cases",
                  route: "/insurance-cases",
                },
                {
                  title: "Insurance Billings",
                  route: "/insurance-billings",
                },
                {
                  title: "Reports",
                  route: "/insurance-reports",
                },
                {
                  title: "Settings",
                  route: "/insurance-settings",
                  innerSubMenu: [
                    {
                      title: "Companies",
                      route: "/insurance-settings/companies",
                    },
                    {
                      title: "Add Services",
                      route: "/insurance-settings/add-services",
                    },
                    {
                      title: "Other settings",
                      route: "/insurance-settings/other-settings",
                    },
                    {
                      title: "Company Billing Templates",
                      route: "/insurance-settings/company-billing-templates",
                    },
                    {
                      title: "Lab Billing Template",
                      route: "/insurance-settings/lab-billing-templates",
                    },
                    {
                      title: "Medicine Billing Template",
                      route: "/insurance-settings/medicine-billing-templates",
                    },
                  ],
                },
              ],
              priority: 45,
            };
            const settingsItem = data.subMenu.find(
              (item: any) => item.route === "/insurance-settings",
            );
            if (settingsItem?.innerSubMenu) {
              if (!accessConfigurations[key]?.view_companies) {
                settingsItem.innerSubMenu = settingsItem.innerSubMenu.filter(
                  (item: any) => item.route !== "/insurance-settings/companies",
                );
              }
              if (!accessConfigurations[key]?.view_services) {
                settingsItem.innerSubMenu = settingsItem.innerSubMenu.filter(
                  (item: any) => item.route !== "/insurance-settings/add-services",
                );
              }
            }
            if (accessConfigurations[key]?.view_insurance_cards === false) {
              let index = data?.subMenu?.findIndex(
                (item: any) => item.route === "/insurance-cards",
              );
              if (index >= 0) data?.subMenu?.splice(index, 1);
            }
            if (accessConfigurations[key]?.view_insurance_cases === false) {
              data.subMenu = data.subMenu.filter(
                (item: any) =>
                  item.route !== "/insurance-cases" && item.route !== "/insurance-billings",
              );
            }
            if (!accessConfigurations[key]?.view_reports) {
              let index = data?.subMenu?.findIndex(
                (item: any) => item.route === "/insurance-reports",
              );
              data?.subMenu?.splice(index, 1);
            }
            if (projectProfile?.departmentsAccess?.includes("insurance")) {
              options.push(data);
            }
          }
          break;
        case "expense":
          let data = {
            title: "Expense",
            icon: <InsuranceIcon />,
            patch: "/expense",

            priority: 60,
          };

          break;
        //income
        case "income":
          let data1 = {
            title: "Income",
            icon: <InsuranceIcon />,
            patch: "/income",
            priority: 70,
          };
          break;
        case "Lab":
          if (
            accessConfigurations[key]?.view_module &&
            projectProfile?.departmentsAccess?.includes("pathology")
          ) {
            // Create a copy of pathology to avoid modifying the original object
            let labData = { ...pathology, subMenu: [...pathology.subMenu] };

            // Remove Settings submenu if can_update_settings is false
            if (!accessConfigurations[key]?.can_update_settings) {
              let index = labData.subMenu.findIndex(
                (item: any) => item.title === "Settings",
              );
              if (index !== -1) {
                labData.subMenu.splice(index, 1);
              }
            }

            // Remove Lab Settings submenu if lab_settings is false
            if (!accessConfigurations[key]?.lab_settings) {
              let index = labData.subMenu.findIndex(
                (item: any) => item.title === "Lab Settings",
              );
              if (index !== -1) {
                labData.subMenu.splice(index, 1);
              }
            }

            // Remove Registration submenu if can_register is false
            if (!accessConfigurations[key]?.can_register) {
              let index = labData.subMenu.findIndex(
                (item: any) => item.title === "Registration",
              );
              if (index !== -1) {
                labData.subMenu.splice(index, 1);
              }
            }

            options.push(labData);
          }
          break;
        case "reports":
          if (
            !accessConfigurations[key]?.view_module &&
            options.some((obj: any) => obj.title === "Appointments")
          ) {
            let getSubMenu = options.find(
              (item: any) => item?.title === "Appointments",
            )["subMenu"];
            let findIndex = getSubMenu.findIndex(
              (item: any) => item.title === "Reports",
            );
            options
              .find((item: any) => item?.title === "Appointments")
              ["subMenu"].splice(findIndex, 1);
          }
          break;
        case "counter":
          if (
            !accessConfigurations[key]?.view_module &&
            options.some((obj: any) => obj.title === "Appointments")
          ) {
            let getSubMenu = options.find(
              (item: any) => item?.title === "Appointments",
            )["subMenu"];
            let findIndex = getSubMenu.findIndex(
              (item: any) => item.title === "Counter",
            );
            options
              .find((item: any) => item?.title === "Appointments")
              ["subMenu"].splice(findIndex, 1);
          }
          break;
        case "deleteHistory":
          if (
            !accessConfigurations[key]?.view_module &&
            options.some((obj: any) => obj.title === "Appointments")
          ) {
            let getSubMenu = options.find(
              (item: any) => item?.title === "Appointments",
            )["subMenu"];
            let findIndex = getSubMenu.findIndex(
              (item: any) => item.title === "Delete History",
            );
            options
              .find((item: any) => item?.title === "Appointments")
              ["subMenu"].splice(findIndex, 1);
          }
          break;
        case "Account":
          if (accessConfigurations[key]?.view_module) {
            // Only show Account if view_module is true
            if (projectProfile?.departmentsAccess.includes("Account")) {
              // Remove Setting submenu if can_update_settings is false
              if (!accessConfigurations[key]?.can_update_settings) {
                let index = account.subMenu.findIndex(
                  (item: any) => item.title === "Setting",
                );
                if (index !== -1) {
                  account.subMenu.splice(index, 1);
                }
              }
              // Remove Procedure submenu if can_add_invoice is false
              if (!accessConfigurations[key]?.can_add_invoice) {
                let index = account.subMenu.findIndex(
                  (item: any) => item.title === "Procedure",
                );
                if (index !== -1) {
                  account.subMenu.splice(index, 1);
                }
              }
              options.push(account);
            }
          }
          break;

        default:
          // setRestrictPrivatePaths(PrivatePaths);
          break;
      }
    });
  if (category?.includes("superAdmin")) {
    options.push(
      {
        title: "Dashboard",
        icon: <GridViewRoundedIcon />,
        patch: "/hospital_dashboard",

        priority: 75,
      },
      {
        title: "Hospitals",
        icon: <AdminPanelSettingsIcon />,
        patch: "/super-admin-dashboard",
        subMenu: [
          {
            title: "Admins",
            route: "/all-admins",
          },
          {
            title: "Flag Hospital",
            route: "/flagged-hospitals",
          },
        ],
        priority: 90,
      },
      {
        title: "Online Revenue",
        icon: <GridViewRoundedIcon />,
        patch: "/online-revenue",

        priority: 105,
      },
    );
  }
  if (category?.includes("admin") && !category.includes("superAdmin")) {
    options.push({
      title: "Settings",
      icon: <AccessConfigIcon />,
      patch: "/access-config",
      priority: 120,
      subMenu: [
        {
          title: "Access Config",
          route: "/access-config",
        },
        {
          title: "Default Config",
          route: "/default-config",
        },
        {
          title: "Default Header&Footer",
          route: "/default-header-footer",
        },
        {
          title: "Disposal Option",
          route: "/disposal-option",
        },
      ],
    });

    options.push({
      title: "Hospital Documents",
      icon: <UploadFileOutlined sx={{ height: "20px" }} />,
      patch: "/hospital-records",
      priority: 122,
    });
  }
  const handleItemClick = (index: number) => {
    setActiveSubMenu("");
    setActiveInnerMenu("");
    setSubIndex(null);
    if (options[index].title === "Appointments") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/appointment-dashboard"); // Navigate to '/' route
    } else if (options[index].title === "Counter") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/counter"); // Navigate to '/' route
    } else if (options[index].title === "Insurance") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/insurance-dashboard");
    } // Navigate to '/' route
    else if (options[index].title === "Account") {
      setActiveIndex(activeIndex === index ? null : index);
      navigate("/account/dashboard");
    } else if (options[index].title === "Expense") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/expense"); // Navigate to '/' route
    }
    //
    else if (options[index].title === "Income") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/income"); // Navigate to '/' route
    }
    //
    else if (options[index].title === "Reports") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/user-reports"); // Navigate to '/' route
    } else if (options[index].title === "Employee") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/employee"); // Navigate to '/' route
    } else if (options[index].title === "Lab") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/mylab/dashboard"); // Navigate to '/' route
    } else if (options[index].title === "Account") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
    } else if (options[index].title === "Income & Expense") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/income&expense/income"); // Navigate to '/' route
    } else if (options[index].title === "OPD") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/opd-dashboard"); // Navigate to '/' route
    } else if (options[index].title === "Diagnostic Services") {
      setActiveIndex(index);
      navigate(options[index].patch);
    } else if (options[index].title === "Account") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/account/dashboard"); // Navigate to '/' route
    } else if (options[index].title === "IPD") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/ipd-dashboard"); // Navigate to '/' route
    } else if (options[index].title === "Settings") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/access-config"); // Navigate to '/' route
    } else if (options[index].title === "Hospital Documents") {
      setActiveIndex(activeIndex === index ? null : index);
      navigate("/hospital-records");
    } else if (options[index].title === "Blood Bank") {
      setActiveIndex(activeIndex === index ? null : index);
      navigate("/blood-bank");
    } else if (options[index].title === "Pharmacy") {
      setActiveIndex(index);
      navigate("/pharmacy");
    } else if (options[index].title === "Hospital Reports") {
      setActiveIndex(index);
      navigate("/hospital-reports");
    } else if (options[index].title === "Settings") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/access-config"); // Navigate to '/' route
    } else if (options[index].title === "Hospitals") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/super-admin-dashboard");
    } else if (options[index].title === "Dashboard") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/hospital_dashboard");
    } else if (options[index].title === "Online Revenue") {
      setActiveIndex(activeIndex === index ? null : index); // Toggle active index for accordion
      navigate("/online-revenue");
    } else if (options[index].title === "Home") {
      setActiveIndex(index);
      navigate("/");
    } else {
      setActiveIndex(activeIndex === index ? null : index);
    }
  };
  options.push({
    title: "Home",
    icon: <Home />,
    patch: "/",
    priority: -10,
  });
  options.sort((a: any, b: any) => a.priority - b.priority);
  const handleSubMenuClick = (route: string, subMenuIndex: number) => {
    setActiveInnerMenu("");
    if (subMenuIndex !== null) {
      setSubIndex(subMenuIndex);
    }
    navigate(route);
    setActiveSubMenu(route); // Update activeSubMenu state with the route
  };
  const handleInnerSubMenuClick = (route: string) => {
    navigate(route);
    setActiveInnerMenu(route);
    // setActiveSubMenu(route); // Update activeSubMenu state with the route
  };
  const menuRouteActive = (route: string, pathname: string, allowChildren: boolean) => {
    if (!route) return false;
    if (pathname === route) return true;
    if (!allowChildren || route === "/") return false;
    if (route === "/insurance-settings/companies") {
      return (
        pathname.startsWith("/insurance-settings/companies/") ||
        pathname === "/companies" ||
        pathname.startsWith("/add-new-company") ||
        pathname.startsWith("/edit-company/") ||
        pathname.startsWith("/view-company/")
      );
    }
    if (route === "/insurance-settings/add-services") {
      return pathname === "/insurance-services" || pathname.startsWith("/insurance-services/");
    }
    if (route === "/insurance-settings/other-settings") {
      return (
        pathname === "/insurance-settings/id-types" ||
        pathname === "/insurance-id-types"
      );
    }
    return pathname.startsWith(`${route}/`);
  };

  useEffect(() => {
    options &&
      options.map((item: any, index: any) => {
        if (
          item.patch === location.pathname ||
          (item.patch &&
            item.patch !== "/" &&
            location.pathname.startsWith(`${item.patch}/`))
        ) {
          setActiveIndex(index);
        } else if (item?.subMenu) {
          item.subMenu.map((item2: any, index2: number) => {
            if (item2.innerSubMenu?.length) {
              if (item2.route === location.pathname) {
                setActiveIndex(index);
                setActiveSubMenu(item2.route);
                setSubIndex(index2);
              } else {
                item2.innerSubMenu.map((item3: any) => {
                  if (menuRouteActive(item3.route, location.pathname, true)) {
                    setActiveIndex(index);
                    setActiveSubMenu(item2.route);
                    setSubIndex(index2);
                    setActiveInnerMenu(item3.route);
                  }
                });
              }
            } else if (menuRouteActive(item2.route, location.pathname, true)) {
              setActiveIndex(index);
              setActiveSubMenu(item2.route);
            }
          });
        }
      });
  }, [profileLoading, location.pathname]);
  return (
    <Box>
      {isSmallScreen ? (
        <Drawer
          anchor="left"
          open={isOpen}
          sx={{
            width: isSmallScreen ? "80%" : 340,
          }}
          onClick={closeDrawer}
        >
          <div>
            <IconButton onClick={closeDrawer} sx={{ alignSelf: "flex-end" }}>
              <Close />
            </IconButton>
          </div>
          <List>
            {options.map((option: any, index: any) => (
              <React.Fragment key={index}>
                <ListItem
                  key={option.title}
                  disablePadding
                  sx={{
                    background:
                      activeIndex === index ? "#f9fbff" : "transparent",
                    borderLeft:
                      activeIndex === index
                        ? "4px solid #077DD3"
                        : "transparent",
                  }}
                >
                  <ListItemButton onClick={() => handleItemClick(index)}>
                    <ListItemIcon
                      sx={{
                        filter:
                          activeIndex === index
                            ? "invert(24%) sepia(98%) saturate(6571%) hue-rotate(183deg) brightness(93%) contrast(92%)"
                            : "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
                      }}
                    >
                      {option.icon}
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        filter:
                          activeIndex === index
                            ? "invert(24%) sepia(98%) saturate(6571%) hue-rotate(183deg) brightness(93%) contrast(92%)"
                            : "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
                        "& .MuiTypography-root": {
                          fontSize: {
                            md: "0.8em",
                            xs: "0.6em",
                            xl: "0.8em",
                            sm: "0.6em",
                            lg: "0.8em",
                          },
                        },
                      }}
                    >
                      {option.title}
                    </ListItemText>
                    {activeIndex === index ? (
                      <ArrowRight color="primary" />
                    ) : (
                      ""
                    )}
                  </ListItemButton>
                </ListItem>
                {activeIndex === index && (
                  <List sx={{ pl: isSmallScreen ? "0" : "80px" }}>
                    {option.subMenu?.map((subOption: any, subIndex1: any) => (
                      <React.Fragment key={subIndex1}>
                        {/* Submenu Item */}
                        <ListItem
                          className={
                            activeSubMenu === subOption.route ? "active" : ""
                          }
                          sx={{
                            color:
                              activeSubMenu === subOption.route
                                ? "#077DD3"
                                : "#3F3F3F",
                            cursor: "pointer",
                            background:
                              activeSubMenu === subOption.route
                                ? "#f9fbff"
                                : "transparent",
                            borderLeft:
                              activeSubMenu === subOption.route
                                ? "4px solid #077DD3"
                                : "transparent",
                          }}
                          onClick={() =>
                            handleSubMenuClick(subOption.route, subIndex1)
                          }
                        >
                          <ArrowRight />
                          <ListItemText
                            primary={subOption.title}
                            sx={{
                              "& .MuiTypography-root": { fontSize: "0.8em" },
                            }}
                          />
                        </ListItem>

                        {/* Render Inner Submenus */}
                        {subIndex1 === subIndex && subOption.innerSubMenu && (
                          <List sx={{ pl: "20px" }}>
                            {subOption.innerSubMenu.map(
                              (subOption2: any, subIndex2: any) => (
                                <React.Fragment key={subIndex2}>
                                  <ListItem
                                    className={
                                      activeInnerMenu === subOption2.route
                                        ? "active"
                                        : ""
                                    }
                                    sx={{
                                      color:
                                        activeInnerMenu === subOption2.route
                                          ? "#077DD3"
                                          : "#3F3F3F",
                                      cursor: "pointer",
                                      background:
                                        activeInnerMenu === subOption2.route
                                          ? "#f9fbff"
                                          : "transparent",
                                      borderLeft:
                                        activeInnerMenu === subOption2.route
                                          ? "4px solid #077DD3"
                                          : "transparent",
                                    }}
                                    onClick={() =>
                                      handleInnerSubMenuClick(subOption2.route)
                                    }
                                  >
                                    <ArrowRight />
                                    <ListItemText
                                      primary={subOption2.title}
                                      sx={{
                                        "& .MuiTypography-root": {
                                          fontSize: "0.8em",
                                        },
                                      }}
                                    />
                                  </ListItem>

                                  {/* Render newInnerSubMenuMedicine ONLY inside 'Medicine' submenu */}
                                  {subOption2.title === "Medicine" &&
                                    subOption2.newInnerSubMenuMedicine && (
                                      <List sx={{ pl: "20px" }}>
                                        {subOption2.newInnerSubMenuMedicine.map(
                                          (subOption3: any, subIndex3: any) => (
                                            <ListItem
                                              key={subIndex3}
                                              className={
                                                activeInnerMenu ===
                                                subOption3.route
                                                  ? "active"
                                                  : ""
                                              }
                                              sx={{
                                                color:
                                                  activeInnerMenu ===
                                                  subOption3.route
                                                    ? "#077DD3"
                                                    : "#3F3F3F",
                                                cursor: "pointer",
                                                background:
                                                  activeInnerMenu ===
                                                  subOption3.route
                                                    ? "#f9fbff"
                                                    : "transparent",
                                                borderLeft:
                                                  activeInnerMenu ===
                                                  subOption3.route
                                                    ? "4px solid #077DD3"
                                                    : "transparent",
                                              }}
                                              onClick={() =>
                                                handleInnerSubMenuClick(
                                                  subOption3.route,
                                                )
                                              }
                                            >
                                              <ArrowRight />
                                              <ListItemText
                                                primary={subOption3.title}
                                                sx={{
                                                  "& .MuiTypography-root": {
                                                    fontSize: "0.8em",
                                                  },
                                                }}
                                              />
                                            </ListItem>
                                          ),
                                        )}
                                      </List>
                                    )}
                                </React.Fragment>
                              ),
                            )}
                          </List>
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                )}
              </React.Fragment>
            ))}
          </List>
        </Drawer>
      ) : (
        <Box
          className={isOpen ? "drawer open" : "drawer closed"}
          role="presentation"
          sx={{
            height: "90vh",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#055FFC",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          <List>
            {options.map((option: any, index: any) => (
              <React.Fragment key={index}>
                <ListItem
                  key={option.title}
                  disablePadding
                  sx={{
                    background:
                      activeIndex === index ? "#f9fbff" : "transparent",
                    borderLeft:
                      activeIndex === index
                        ? "4px solid #077DD3"
                        : "transparent",
                  }}
                >
                  <ListItemButton onClick={() => handleItemClick(index)}>
                    <ListItemIcon
                      sx={{
                        filter:
                          activeIndex === index
                            ? "invert(24%) sepia(98%) saturate(6571%) hue-rotate(183deg) brightness(93%) contrast(92%)"
                            : "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
                      }}
                    >
                      {option.icon}
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        filter:
                          activeIndex === index
                            ? "invert(24%) sepia(98%) saturate(6571%) hue-rotate(183deg) brightness(93%) contrast(92%)"
                            : "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
                        "& .MuiTypography-root": {
                          fontSize: {
                            md: "0.8em",
                            xs: "0.6em",
                            xl: "0.8em",
                            sm: "0.6em",
                            lg: "0.8em",
                          },
                        },
                      }}
                    >
                      {option.title}
                    </ListItemText>
                    {activeIndex === index ? (
                      <ArrowRight color="primary" />
                    ) : (
                      ""
                    )}
                  </ListItemButton>
                </ListItem>
                {activeIndex === index && (
                  <List sx={{ pl: "30px" }}>
                    {option.subMenu?.map((subOption: any, subIndex1: any) => (
                      <React.Fragment key={subIndex1}>
                        {/* Submenu Item */}
                        <ListItem
                          className={
                            activeSubMenu === subOption.route ? "active" : ""
                          }
                          sx={{
                            color:
                              activeSubMenu === subOption.route
                                ? "#077DD3"
                                : "#3F3F3F",
                            cursor: "pointer",
                            background:
                              activeSubMenu === subOption.route
                                ? "#f9fbff"
                                : "transparent",
                            borderLeft:
                              activeSubMenu === subOption.route
                                ? "4px solid #077DD3"
                                : "transparent",
                          }}
                          onClick={() =>
                            handleSubMenuClick(subOption.route, subIndex1)
                          }
                        >
                          <ArrowRight />
                          <ListItemText
                            primary={subOption.title}
                            sx={{
                              "& .MuiTypography-root": { fontSize: "0.8em" },
                            }}
                          />
                        </ListItem>

                        {/* Render Inner Submenus */}
                        {subIndex1 === subIndex && subOption.innerSubMenu && (
                          <List sx={{ pl: "20px" }}>
                            {subOption.innerSubMenu.map(
                              (subOption2: any, subIndex2: any) => (
                                <React.Fragment key={subIndex2}>
                                  <ListItem
                                    className={
                                      activeInnerMenu === subOption2.route
                                        ? "active"
                                        : ""
                                    }
                                    sx={{
                                      color:
                                        activeInnerMenu === subOption2.route
                                          ? "#077DD3"
                                          : "#3F3F3F",
                                      cursor: "pointer",
                                      background:
                                        activeInnerMenu === subOption2.route
                                          ? "#f9fbff"
                                          : "transparent",
                                      borderLeft:
                                        activeInnerMenu === subOption2.route
                                          ? "4px solid #077DD3"
                                          : "transparent",
                                    }}
                                    onClick={() =>
                                      handleInnerSubMenuClick(subOption2.route)
                                    }
                                  >
                                    <ArrowRight />
                                    <ListItemText
                                      primary={subOption2.title}
                                      sx={{
                                        "& .MuiTypography-root": {
                                          fontSize: "0.8em",
                                        },
                                      }}
                                    />
                                  </ListItem>

                                  {/* Render newInnerSubMenuMedicine ONLY inside 'Medicine' submenu */}
                                  {subOption2.title === "Medicine" &&
                                    subOption2.newInnerSubMenuMedicine && (
                                      <List sx={{ pl: "20px" }}>
                                        {subOption2.newInnerSubMenuMedicine.map(
                                          (subOption3: any, subIndex3: any) => (
                                            <ListItem
                                              key={subIndex3}
                                              className={
                                                activeInnerMenu ===
                                                subOption3.route
                                                  ? "active"
                                                  : ""
                                              }
                                              sx={{
                                                color:
                                                  activeInnerMenu ===
                                                  subOption3.route
                                                    ? "#077DD3"
                                                    : "#3F3F3F",
                                                cursor: "pointer",
                                                background:
                                                  activeInnerMenu ===
                                                  subOption3.route
                                                    ? "#f9fbff"
                                                    : "transparent",
                                                borderLeft:
                                                  activeInnerMenu ===
                                                  subOption3.route
                                                    ? "4px solid #077DD3"
                                                    : "transparent",
                                              }}
                                              onClick={() =>
                                                handleInnerSubMenuClick(
                                                  subOption3.route,
                                                )
                                              }
                                            >
                                              <ArrowRight />
                                              <ListItemText
                                                primary={subOption3.title}
                                                sx={{
                                                  "& .MuiTypography-root": {
                                                    fontSize: "0.8em",
                                                  },
                                                }}
                                              />
                                            </ListItem>
                                          ),
                                        )}
                                      </List>
                                    )}
                                </React.Fragment>
                              ),
                            )}
                          </List>
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                )}
              </React.Fragment>
            ))}
          </List>
          {/* Add WhatsAppButton at the bottom */}

       
          <Box sx={{ position: "absolute", bottom: 20, left: 20 }}>
            <WhatsAppButtonWithTooltip></WhatsAppButtonWithTooltip>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SideBar;
